import React, { useEffect } from 'react'
import { Marker, Popup, useMap } from 'react-leaflet'

export const LocationMarker = ({ position }) => {
    const map = useMap()

    useEffect(() => {
        if (position?.lat) {
            setTimeout(() => {
                map.flyTo(position, 7)
            }, 500)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [position])

    return position === null ? null : (
        <Marker position={position}>
            <Popup>Estás Aquí</Popup>
        </Marker>
    )
}